export const GROUP_VALUE_CREATE_REQUEST = 'GROUP_VALUE_CREATE_REQUEST';
export const GROUP_VALUE_CREATE = 'GROUP_VALUE_CREATE';

export const GROUP_VALUE_DELETE_REQUEST = 'GROUP_VALUE_DELETE_REQUEST';
export const GROUP_VALUE_DELETE = 'GROUP_VALUE_DELETE';

export const GROUP_VALUE_FETCH_REQUEST = 'GROUP_VALUE_FETCH_REQUEST';
export const GROUP_VALUE_FETCH = 'GROUP_VALUE_FETCH';
